<template>
  <section
    class="fixed inset-x-0 bottom-0 z-10 block border-t border-ontick-carbon-500 bg-ontick-graphite-500 shadow-lg md:hidden"
  >
    <div class="flex justify-between">
      <button
        @click="$emit('update')"
        class="inline-block w-full justify-center pt-2 pb-1 text-center"
      >
        <span
          class="inline-block"
          :class="active ? 'text-ontick-blue-500' : 'text-gray-400'"
          v-html="active ? icon.active : icon.disabled"
        >
        </span>

        <span
          :class="active ? 'text-white' : 'text-gray-400'"
          class="block text-xs"
        >
          Atualizar</span
        >
      </button>
      <a
        @click="$emit('select_menu', item)"
        v-for="item in menu"
        :key="item.label"
        href="#"
        class="inline-block w-full justify-center pt-2 pb-1 text-center"
      >
        <span
          class="inline-block"
          :class="item.active ? 'text-ontick-blue-500' : 'text-gray-400'"
          v-html="item.icon"
        ></span>

        <span
          :class="item.active ? 'text-white' : 'text-gray-400'"
          class="tab tab-home block text-xs"
          >{{ item.label }}</span
        >
      </a>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    menu: { type: Array, default: null },
    active: { type: Boolean },
    icon: { type: Object },
  },
};
</script>

<style></style>
